// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5l-2";
export var blackBorderOnHover = "_5l-7";
export var cell = "_5l-6";
export var cellContainer = "_5l-3";
export var checked = "_5l-8";
export var disabled = "_5l-5";
export var featuredIconCellContainer = "_5l-9";
export var featuredIconTextContainer = "_5l-b";
export var featuredIconWrapper = "_5l-a";
export var noBorder = "_5l-c";
export var orangeSelectedRow = "_es-3";
export var overflowableText = "_5l-0";
export var overflowableTextContainer = "_5l-1";
export var row = "_5n-0";
export var rowCheckboxCell = "_5l-4";
export var selectableTable = "_es-2";